import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function ArrowLeftIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.25 7.27441L16.25 7.27441"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.2998 13.2988L1.2498 7.27476L7.2998 1.24976"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
